import React from 'react';
import { CircularProgress } from '@mui/material';
import { LoadingPageWrapper } from './styling';

function LoadingPage() {
  return (
    <LoadingPageWrapper>
      <CircularProgress size={60}/>
    </LoadingPageWrapper>
  );
}

export default LoadingPage;
